import { ITrPlural, tPlural } from '../translate';

// const toPluralShort = (word: string): string => {
//     if (word.endsWith('y') && !'aeiou'.includes(word[word.length - 2])) {
//         return `${word.slice(0, -1)}ies`;
//     }
//
//     if (word.endsWith('s') || word.endsWith('x') || word.endsWith('z') || word.endsWith('ch') || word.endsWith('sh')) {
//         return `${word}es`;
//     }
//
//     return `${word}s`;
// };

// const toSingularShort = (word: string): string => {
//     if (word.endsWith('ies')) {
//         return `${word.slice(0, -3)}y`;
//     }
//
//     if (word.endsWith('s')) {
//         return word.slice(0, -1);
//     }
//
//     return word;
// };

const toPlural = (word: string): string => {
    if (word.endsWith('y') && !'aeiou'.includes(word[word.length - 2])) {
        return `${word.slice(0, -1)}ies`;
    }

    if (word.endsWith('s') || word.endsWith('x') || word.endsWith('z') || word.endsWith('ch') || word.endsWith('sh')) {
        return `${word}es`;
    }

    return `${word}s`;
};

const toSingular = (word: string): string => {
    if (word.endsWith('ies')) {
        return `${word.slice(0, -3)}y`;
    }

    if (
        word.endsWith('ses') ||
        word.endsWith('xes') ||
        word.endsWith('zes') ||
        word.endsWith('ches') ||
        word.endsWith('shes')
    ) {
        return word.slice(0, -2);
    }

    if (word.endsWith('s')) {
        return word.slice(0, -1);
    }

    return word;
};

export const tAdvancedPlural = (text: string, count = 0): string => {
    const singularText = toSingular(text.toLowerCase());
    const translated = tPlural(singularText as ITrPlural, count);
    if (translated !== singularText) {
        return translated;
    }
    return count === 1 ? `1 ${singularText}` : `${count} ${toPlural(singularText)}`;
};

export const makeSelectionLabel = (title: string, count = 0): string => {
    const singularTitle = toSingular(title.toLowerCase());
    const selectedKey = `selected_${singularTitle}`;
    const translated = tPlural(selectedKey as ITrPlural, count);
    if (translated !== selectedKey) {
        return translated;
    }

    return count === 1 ? `1 ${singularTitle} selected` : `${count} ${toPlural(singularTitle)} selected`;
};
